import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import styles from './ScoreDifference.module.scss';

type ScoreDifferenceProps = {
  firstPoints: number;
  secondPoints: number;
  hideDifference?: boolean;
};

function ScoreDifference({
  firstPoints,
  secondPoints,
  hideDifference,
}: ScoreDifferenceProps) {
  const difference = secondPoints - firstPoints;

  function getIconProps(): {icon: IconName; color: string} {
    if (difference === 0) {
      return {icon: 'equals', color: '#414449'};
    }

    if (difference > 0) {
      return {icon: 'circle-up', color: '#00c660'};
    }

    return {icon: 'circle-down', color: '#f24e54'};
  }

  const {icon, color} = getIconProps();

  return (
    <div className={styles.container}>
      <FontAwesomeIcon icon={['fad', icon]} color={color} />
      {!hideDifference && <strong>{difference}</strong>}
    </div>
  );
}

export default ScoreDifference;
